import React from 'react';
import { Navigate } from 'react-router-dom';

import { locationLoader } from '@/core/router/loaders/locationLoader';
import { isFirstStepSkipped } from '@/core/utils/rapidstor';
import BookUnitGuard from '@/journey-based-listing/screens/book-unit-guard';
import BookUnitMap from '@/journey-based-listing/screens/book-unit-map';
import CustomiseBooking from '@/journey-based-listing/screens/customise-booking';
import Error from '@/journey-based-listing/screens/error';
import Index from '@/journey-based-listing/screens/index';
import TestRoot from '@/journey-based-listing/screens/tests/root';
import UnitListing from '@/journey-based-listing/screens/unit-listing';

import ComponentsTestScreen from '@/journey-based-listing/screens/tests/components';

import { wizardScreens } from './common/wizardScreens';

export function buildJblRoutes() {
    const screens = [
        {
            path: '',
            element: <Index />,
            loader: locationLoader,
            errorElement: <Error />,
        },
        { path: 'rapidstor', element: <Navigate to="/" replace /> },
        { path: '_rapidstor', element: <Navigate to="/" replace /> },
        {
            path: 'unit-listing',
            element: <UnitListing />,
            loader: locationLoader,
            errorElement: <Error />,
        },
        {
            path: 'customise-booking',
            element: <CustomiseBooking />,
            loader: locationLoader,
            errorElement: <Error />,
        },
        ...wizardScreens,
    ];

    if (isFirstStepSkipped()) {
        const indexScreenIdx = screens.findIndex((s) => s.path === '');
        if (indexScreenIdx !== -1) screens.splice(indexScreenIdx, 1);
        const unitListing = screens.find((s) => s.path === 'unit-listing');
        if (unitListing) unitListing.path = ''; // Promote to index.
        // Redirect the old path so reloads at #/unit-listing still work.
        screens.push({ path: 'unit-listing', element: <Navigate to="/" replace /> });
    }

    // MODE rather than NODE_ENV so the Playwright bundle (built with --mode development) keeps these.
    if (import.meta.env.MODE !== 'production') {
        screens.push(
            {
                path: '/tests',
                element: <TestRoot />,
                loader: locationLoader,
                errorElement: <Error />,
            },
            {
                path: '/tests/components',
                element: <ComponentsTestScreen />,
                loader: locationLoader,
                errorElement: <Error />,
            },
        );
    }

    // BookUnitGuard handles redirect and standard/map variant selection
    if (window.rapidstor_settings.app_config.journey.dev) {
        screens.push(
            {
                path: 'book-unit',
                element: <BookUnitGuard />,
                loader: locationLoader,
                errorElement: <Error />,
            },
            {
                path: 'book-unit-map',
                element: <BookUnitMap />,
                loader: locationLoader,
                errorElement: <Error />,
            },
        );
    } else {
        screens.push({
            path: 'book-unit',
            element: <BookUnitGuard />,
            loader: locationLoader,
            errorElement: <Error />,
        });
    }

    return screens;
}
